import React, { Component } from 'react'

import MyPageNavigation from 'components/Navigation/MyPageNavigation'
import ScrollToTop from 'components/UI/ScrollToTop'
import './style.scss'

class MobileMyPage extends Component {
    render() {
        return (
            <div className="mobile-my-page">
                <ScrollToTop />
                <h1>Min side</h1>
                <MyPageNavigation />
            </div>
        )
    }
}

export default MobileMyPage
